import { useState } from 'react';
import { PRESET_COLORS } from './vehicleRegisterUtils';

export default function VehicleColorPicker({ value, disabled, onChange }) {
  const [open, setOpen] = useState(false);
  const [draft, setDraft] = useState('');
  const [error, setError] = useState('');
  const selected = PRESET_COLORS.find(color => color.value === value);

  const show = () => { setDraft(selected ? '' : value); setError(''); setOpen(true); };
  const choose = color => { onChange(color.value); setOpen(false); };
  const confirmManual = () => {
    const next = draft.trim();
    if (!next) { setError('نام رنگ را وارد کنید'); return; }
    onChange(next);
    setOpen(false);
  };

  return <>
    <div className="veh-color">
      <span className="veh-reg__label">رنگ خودرو</span>
      <button type="button" className={`veh-color__trigger${!value ? ' is-placeholder' : ''}`} onClick={show} disabled={disabled} aria-label="رنگ خودرو"><i style={{ background: selected?.hex || 'transparent' }} aria-hidden="true" /><span><b>{value || 'انتخاب رنگ'}</b><small>{value ? 'برای تغییر لمس کنید' : 'رنگ‌های پرکاربرد یا ورود دستی'}</small></span><em aria-hidden="true" /></button>
    </div>

    {open && <div className="veh-picker-overlay" onClick={event => { event.stopPropagation(); setOpen(false); }}>
      <div className="veh-picker veh-color-picker" role="dialog" aria-modal="true" aria-label="انتخاب رنگ خودرو" onClick={event => event.stopPropagation()}>
        <div className="veh-picker__head"><div><b>رنگ خودرو</b><small>یک رنگ را انتخاب یا نام آن را وارد کنید</small></div><button type="button" onClick={() => setOpen(false)} aria-label="بستن انتخاب رنگ">×</button></div>
        <div className="veh-color-picker__grid" role="listbox" aria-label="رنگ‌های خودرو">{PRESET_COLORS.map(color => <button type="button" role="option" aria-selected={value === color.value} key={color.value} onClick={() => choose(color)}><i style={{ background: color.hex }} /><span>{color.value}</span></button>)}</div>
        <div className="veh-color-picker__manual"><label htmlFor="veh-color-manual">رنگ دلخواه</label><div><input id="veh-color-manual" value={draft} onChange={event => { setDraft(event.target.value); setError(''); }} placeholder="مثال: زغالی" /><button type="button" onClick={confirmManual}>تأیید</button></div><p className={`veh-picker__error${error ? ' is-visible' : ''}`}>{error || ' '}</p></div>
      </div>
    </div>}
  </>;
}
